module.exports = __webpack_public_path__ + "static/img/banner_top.8606623.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_top.png
// module id = 7gMG
// module chunks = 3